module.exports = __webpack_public_path__ + "static/media/bbq-text-3.ac16062e.jpg";